import { useEffect } from "react"
import { TableInstance } from "react-table"

// HOOKS
export default function useHiddenColumns<T extends object>(table: TableInstance<T>, hiddenColumns?: any[]) {
    const { columns, setHiddenColumns } = table
    useEffect(() => {
        hiddenColumns && setHiddenColumns(hiddenColumns)
    }, [hiddenColumns, columns])
}